import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from '@/views/login'
// import HomeView from '@/views/HomeView'
import homepage from '@/views/homepage'
import picRecongnition from '@/views/picRecongnition'
import picRecongnitionTakePhoto from '@/views/picRecongnitionTakePhoto'
import SNPage from '@/views/SNPage'
import SNPageTest from '@/views/SNPageTest'
import inventoryCheck from '@/views/inventoryCheck'
import BSNewPhone from '@/views/BSNewPhone'
import returnToSupplier from '@/views/returnToSupplier'
import staticQueryPage from '@/views/staticQueryPage'
import depotRepairQueryPage from '@/views/depotRepairQueryPage'
import outBound from '@/views/outBound'
import accessoriesLossReport from '@/views/accessoriesLossReport'
import returnToFactory from '@/views/returnToFactory'
import reWarehousing from '@/views/reWarehousing'
import anchorView from '@/views/anchorView'
import maintainOutBound from '@/views/maintainOutBound'
import home from '@/views/home'
import SelfRepair from '../views/SelfRepair.vue'

// import helloWord from '@/views/helloWord'

import HomeView from '@/views/HomeView'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/',
      name: 'homepage',
      component: homepage,
      children:[
        {
          path: '/login',
          name: 'login',
          component: login,
        },
        {
          path: '/picRecongnitionTakePhoto',
          name: 'picRecongnitionTakePhoto',
          component: picRecongnitionTakePhoto,
        },
        {
          path: '/picRecongnition',
          name: 'picRecongnition',
          component: picRecongnition,
        },
        {
          path: '/SNPage',
          name: 'SNPage',
          component: SNPage,
        },
        {
          path: '/SNPageTest',
          name: 'SNPageTest',
          component: SNPageTest,
        },
        {
          path: '/inventoryCheck',
          name: 'inventoryCheck',
          component: inventoryCheck,
        },
        {
          path: '/BSNewPhone',
          name: 'BSNewPhone',
          component: BSNewPhone,
        },
        {
          path: '/returnToSupplier',
          name: 'returnToSupplier',
          component: returnToSupplier,
        },
        {
          path: '/outBound',
          name: 'outBound',
          component: outBound,
        },
        {
          path: '/accessoriesLossReport',
          name: 'accessoriesLossReport',
          component: accessoriesLossReport,
        },
        {
          path: '/staticQueryPage/:id',
          name: 'staticQueryPage',
          component: staticQueryPage,
          meta: { showMenu: false }
        },
        {
          path: '/depotRepairQueryPage/:id',
          name: 'depotRepairQueryPage',
          component: depotRepairQueryPage,
          meta: { showMenu: false }
        },
        {
          path: '/returnToFactory',
          name: 'returnToFactory',
          component: returnToFactory,
        },
        {
          path: '/reWarehousing',
          name: 'reWarehousing',
          component: reWarehousing,
        },
        {
          path: '/anchorView',
          name: 'anchorView',
          component: anchorView,
        },
        {
          path: '/maintainOutBound',
          name: 'maintainOutBound',
          component: maintainOutBound,
        },
        {
          path: '/home',
          name: 'home',
          component: home,
        },
        {
          path: '/SelfRepair',
          name: 'SelfRepair',
          component: SelfRepair,
        },
        // {
        //   path: '/helloWord',
        //   name: 'helloWord',
        //   component: helloWord,
        // },

      ]
    }
  ]
})

import VueRouter from "vue-router"
//解决路由导航双击出现报错问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js